module.exports = __webpack_public_path__ + "static/media/trailer.898fd994.jpg";